function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import { PageBaseComponent } from "../../library/cms/page-components";
import { Image, H3Title } from "../../library/cms/content-components";
import { TinyEditable } from "../../library/cms/editor";
import MediaManagerEntity from "../../library/cms/media-entity";
import Console from "../../library/console";
import Carousel from "../components/carousel";
export default class extends PageBaseComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "observers", () => {
      var row4Applied = false;
      var row5Applied = false;
      this.row4.classList.add('hidden-2');
      this.row5.classList.add('hidden-2');
      var observer1 = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          var target = entries[0].target;
          target.classList.add('margin-slide-right');
        }
      }, {
        threshold: [0.1]
      });
      var observer2 = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          var target = entries[0].target;
          target.classList.add('margin-slide-top');
        }
      }, {
        threshold: [0.1]
      });
      var observer3 = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          var target = entries[0].target;
          target.classList.add('margin-slide-right');
        }
      }, {
        threshold: [0.1]
      });
      var observer4 = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          var target = entries[0].target;
          target.classList.add('margin-slide-top');
        }
      }, {
        threshold: [0.1]
      });
      var observer5 = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && !row4Applied) {
          var target = entries[0].target;
          target.classList.add('tilt-in-top-1');
          row4Applied = true;
        }
      }, {
        threshold: [0.1]
      });
      var observer6 = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && !row5Applied) {
          var target = entries[0].target;
          target.classList.add('tilt-in-right-2');
          row5Applied = true;
        }
      }, {
        threshold: [0.1]
      });
      observer1.observe(this.image1.Image);
      observer2.observe(this.content1);
      observer3.observe(this.image3.Image);
      observer4.observe(this.row3);
      observer5.observe(this.row4);
      observer6.observe(this.row5);
    });

    _defineProperty(this, "onTitle1Change", title => {
      this.state.component.content.title1 = title;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onTitle2Change", title => {
      this.state.component.content.title2 = title;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onTitle3Change", title => {
      this.state.component.content.title3 = title;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onTitle4Change", title => {
      this.state.component.content.title4 = title;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onTitle5Change", title => {
      this.state.component.content.title5 = title;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onFile1Selected", files => {
      this.state.component.content.image1 = files[0];
      this.setState(this.state.component);
    });

    _defineProperty(this, "onFile2Selected", files => {
      this.state.component.content.image2 = files[0];
      this.setState(this.state.component);
    });

    _defineProperty(this, "onFile3Selected", files => {
      this.state.component.content.image3 = files[0];
      this.setState(this.state.component);
    });

    _defineProperty(this, "onFile4Selected", files => {
      this.state.component.content.image4 = files[0];
      this.setState(this.state.component);
    });

    _defineProperty(this, "onCarouselFilesSelected", files => {
      this.state.component.content.carousel = files;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onFile5Selected", files => {
      this.state.component.content.image5 = files[0];
      this.setState(this.state.component);
    });

    _defineProperty(this, "onFile6Selected", files => {
      this.state.component.content.image6 = files[0];
      this.setState(this.state.component);
    });

    _defineProperty(this, "onFile7Selected", files => {
      this.state.component.content.image7 = files[0];
      this.setState(this.state.component);
    });

    _defineProperty(this, "onFile8Selected", files => {
      this.state.component.content.image8 = files[0];
      this.setState(this.state.component);
    });
  }

  componentDidMount() {
    super.componentDidMount();
    this.observers();
  }

  onToggleOn() {
    console.log('on toggle on');
    this.row4.classList.remove('hidden-2');
    this.row5.classList.remove('hidden-2');
    this.row4.classList.remove('tilt-in-top-1');
    this.row5.classList.remove('tilt-in-right-2');
  }

  onGetContent(d) {
    var content = {
      image1: this.state.component.content.image1,
      image2: this.state.component.content.image2,
      image3: this.state.component.content.image3,
      image4: this.state.component.content.image4,
      image5: this.state.component.content.image5,
      image6: this.state.component.content.image6,
      image7: this.state.component.content.image7,
      image8: this.state.component.content.image8,
      carousel: this.state.component.content.carousel,
      title1: this.state.component.content.title1,
      html1: this.editor1 ? this.editor1.getContent() : this.state.component.content.html1,
      title2: this.state.component.content.title2,
      title3: this.state.component.content.title3,
      title4: this.state.component.content.title4,
      title5: this.state.component.content.title5
    };
    var data = {
      key: this.props.contentKey,
      content: content
    };
    return data;
  }

  get carousel() {
    var carousel = this.state.component.content.carousel;
    Console.write(carousel);

    if (!carousel) {
      carousel = [];
      var file1 = MediaManagerEntity.getEntity('https://media.r3vstack.com/assets/theorydesign/medialibrary/home-image-4new.jpg', 'home-image-4new.jpg', '.jpg', 'Home');
      carousel.push(file1);
    }

    return carousel;
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "home-content-grid"
    }, /*#__PURE__*/React.createElement("div", {
      className: "home-content-row row-1"
    }, /*#__PURE__*/React.createElement(Image, {
      media: this.state.component.content.image1,
      active: this.state.component.active,
      mediaManagerData: this.props.mediaManagerData,
      onFilesSelected: this.onFile1Selected,
      cls: "row-1-image",
      ref: ref => this.image1 = ref
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex-align-center row-1-content",
      ref: ref => this.content1 = ref
    }, /*#__PURE__*/React.createElement(H3Title, {
      active: this.state.component.active,
      title: this.state.component.content.title1,
      onChange: this.onTitle1Change,
      cls: "italic row-1-header"
    }), /*#__PURE__*/React.createElement(TinyEditable, {
      content: this.state.component.content.html1,
      active: this.state.component.active,
      cls: "margin-top row-1-text",
      ref: ref => this.editor1 = ref
    }))), /*#__PURE__*/React.createElement("div", {
      className: "home-content-row row-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row-alignment relative"
    }, /*#__PURE__*/React.createElement(H3Title, {
      active: this.state.component.active,
      title: this.state.component.content.title2,
      onChange: this.onTitle2Change,
      cls: "italic header-text-margin"
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Image, {
      media: this.state.component.content.image3,
      active: this.state.component.active,
      mediaManagerData: this.props.mediaManagerData,
      onFilesSelected: this.onFile3Selected,
      imgCss: "img-width",
      ref: ref => this.image3 = ref
    }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Image, {
      media: this.state.component.content.image2,
      active: this.state.component.active,
      mediaManagerData: this.props.mediaManagerData,
      onFilesSelected: this.onFile2Selected,
      ref: ref => this.image2 = ref
    }))), /*#__PURE__*/React.createElement("div", {
      className: "home-content-row row-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "full-width relative",
      ref: ref => this.row3 = ref
    }, /*#__PURE__*/React.createElement("div", {
      className: "full-header-backdrop"
    }, /*#__PURE__*/React.createElement(H3Title, {
      active: this.state.component.active,
      title: this.state.component.content.title3,
      onChange: this.onTitle3Change,
      cls: "italic"
    })), /*#__PURE__*/React.createElement(Carousel, {
      files: this.carousel,
      active: this.state.component.active,
      mediaManagerData: this.props.mediaManagerData,
      onFilesSelected: this.onCarouselFilesSelected
    }))), /*#__PURE__*/React.createElement("div", {
      className: "home-content-row row-4",
      ref: ref => this.row4 = ref
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Image, {
      media: this.state.component.content.image5,
      active: this.state.component.active,
      mediaManagerData: this.props.mediaManagerData,
      onFilesSelected: this.onFile5Selected
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex-align-center relative"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(H3Title, {
      active: this.state.component.active,
      title: this.state.component.content.title4,
      onChange: this.onTitle4Change,
      cls: "italic header-text-margin"
    }), /*#__PURE__*/React.createElement(Image, {
      media: this.state.component.content.image6,
      active: this.state.component.active,
      mediaManagerData: this.props.mediaManagerData,
      onFilesSelected: this.onFile6Selected,
      imgCss: "img-width"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "home-content-row row-5",
      ref: ref => this.row5 = ref
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-align-center"
    }, /*#__PURE__*/React.createElement(H3Title, {
      active: this.state.component.active,
      title: this.state.component.content.title5,
      onChange: this.onTitle5Change,
      cls: "italic header-margin-bottom"
    }), /*#__PURE__*/React.createElement(Image, {
      media: this.state.component.content.image7,
      active: this.state.component.active,
      mediaManagerData: this.props.mediaManagerData,
      onFilesSelected: this.onFile7Selected
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Image, {
      media: this.state.component.content.image8,
      active: this.state.component.active,
      mediaManagerData: this.props.mediaManagerData,
      onFilesSelected: this.onFile8Selected
    }))));
  }

}